export default __webpack_public_path__ + "static/media/default-texture-2.0dee4da7.jpg";